import { ItemModel } from "../models/ItemModel";
import { ItemType } from "../types/ItemTypes";

export const initialItems: ItemModel[] = [
  {
    code: "153KJ83",
    description1: "Makita Cordless Pistol-Grip Drill",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/drill_codeless_green.jpg",
    itemType: ItemType.DURABLE,
    unitPrice: 161.54,
    issueCost: 5.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP013",
    mfg: "Makita",
    mfgItem: "019200771825",
    leadTime: 7,
    orderQty: 1,
    dateCreated: new Date("2024-01-01"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "2830D20",
    description1: "Milwaukee General Purpose Cordless Circular Saws",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/power-tools-circular-saw-orange.jpg",
    itemType: ItemType.DURABLE,
    unitPrice: 318.56,
    issueCost: 5.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP012",
    mfg: "Milwaukee",
    mfgItem: "045242520123",
    leadTime: 10,
    orderQty: 1,
    dateCreated: new Date("2024-01-01"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "9150F44",
    description1: "CHANNELLOCK Wrench",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/wrench_150F44.jpg",
    itemType: ItemType.DURABLE,
    unitPrice: 48.79,
    issueCost: 5.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP001",
    mfg: "Channellock",
    mfgItem: "025582301234",
    leadTime: 4,
    orderQty: 1,
    dateCreated: new Date("2024-01-01"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "H9289",
    description1: "CRESCENT 180 precision tools handle most repairs",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/H9289.png",
    itemType: ItemType.DURABLE,
    unitPrice: 185.00,
    issueCost: 5.30,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP003",
    mfg: "Crescent",
    mfgItem: "037103928901",
    leadTime: 7,
    orderQty: 1,
    dateCreated: new Date("2024-01-01"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "18.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "7712A11",
    description1: "DEWALT 20V MAX XR Impact Driver",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/7712A11.png",
    itemType: ItemType.DURABLE,
    unitPrice: 129.00,
    issueCost: 5.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP014",
    mfg: "DEWALT",
    mfgItem: "DCF845B",
    leadTime: 6,
    orderQty: 1,
    dateCreated: new Date("2024-01-02"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "8821B55",
    description1: "Bosch Hammer Drill Kit",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/8821B55.png",
    itemType: ItemType.DURABLE,
    unitPrice: 249.75,
    issueCost: 5.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP015",
    mfg: "Bosch",
    mfgItem: "000346453210",
    leadTime: 8,
    orderQty: 1,
    dateCreated: new Date("2024-01-03"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "5533C77",
    description1: "Stanley Tape Measure 25ft",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/5533C77.png",
    itemType: ItemType.EXPENDABLE,
    unitPrice: 12.49,
    issueCost: 2.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP002",
    mfg: "Stanley",
    mfgItem: "076174305551",
    leadTime: 3,
    orderQty: 1,
    dateCreated: new Date("2024-01-04"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "9912D88",
    description1: "Ridgid Pipe Wrench",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/9912D88.png",
    itemType: ItemType.DURABLE,
    unitPrice: 34.60,
    issueCost: 3.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP003",
    mfg: "Ridgid",
    mfgItem: "095691310005",
    leadTime: 5,
    orderQty: 1,
    dateCreated: new Date("2024-01-05"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "1100E22",
    description1: "Milwaukee Angle Grinder",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/1100E22.png",
    itemType: ItemType.DURABLE,
    unitPrice: 129.99,
    issueCost: 4.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP012",
    mfg: "Milwaukee",
    mfgItem: "045242195678",
    leadTime: 7,
    orderQty: 1,
    dateCreated: new Date("2024-01-06"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "6677F99",
    description1: "Makita Circular Saw Blade",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/6677F99.png",
    itemType: ItemType.EXPENDABLE,
    unitPrice: 22.30,
    issueCost: 2.50,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP013",
    mfg: "Makita",
    mfgItem: "088381234567",
    leadTime: 4,
    orderQty: 1,
    dateCreated: new Date("2024-01-07"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
  },
  {
    code: "2244G11",
    description1: "Klein Tools Screwdriver Set",
    itemImage: "https://d3jdpongi7ohqb.cloudfront.net/2244G11.png",
    itemType: ItemType.DURABLE,
    unitPrice: 59.99,
    issueCost: 3.00,
    uom: 'qty',
    packQty: 1,
    supCode: "SUP016",
    mfg: "Klein Tools",
    mfgItem: "092644850001",
    leadTime: 6,
    orderQty: 1,
    dateCreated: new Date("2024-01-08"),
    active: true,
    disabled: false,
    category: "Tool",
    weigh: false,
    description2: "...",
    weight: "0.0 Pounds",
    notes: '',
    lastIssue: undefined,
    createdBy: '',
    
  },
  {
  code: "EM-10MM-4F",
  description1: "End Mill 10mm 4 Flute Carbide",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/EM-10MM-4F.png",
  itemType: ItemType.DURABLE,
  unitPrice: 45.00,
  issueCost: 50.00,
  uom: 'EA',
  packQty: 10,
  supCode: "SUP001",
  mfg: "Sandvik",
  mfgItem: "R216.34-10030",
  leadTime: 7,
  orderQty: 20,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Cutting Tool",
  weigh: false,
},

{
  code: "EM-6MM-2F",
  description1: "End Mill 6mm 2 Flute HSS",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/EM-6MM-2F.png",
  itemType: ItemType.DURABLE,
  unitPrice: 18.50,
  issueCost: 22.00,
  uom: 'EA',
  packQty: 10,
  supCode: "SUP001",
  mfg: "YG-1",
  mfgItem: "E5E06020",
  leadTime: 5,
  orderQty: 30,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Cutting Tool",
  weigh: false,
},

{
  code: "EM-12MM-4F",
  description1: "End Mill 12mm 4 Flute Carbide",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/EM-12MM-4F.png",
  itemType: ItemType.DURABLE,
  unitPrice: 60.00,
  issueCost: 68.00,
  uom: 'EA',
  packQty: 5,
  supCode: "SUP002",
  mfg: "Kennametal",
  mfgItem: "KSEM1200",
  leadTime: 10,
  orderQty: 15,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Cutting Tool",
  weigh: false,
},

{
  code: "DR-5MM-HSS",
  description1: "Drill Bit 5mm HSS",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/DR-5MM-HSS.png",
  itemType: ItemType.DURABLE,
  unitPrice: 6.50,
  issueCost: 8.00,
  uom: 'EA',
  packQty: 20,
  supCode: "SUP003",
  mfg: "Dormer",
  mfgItem: "A0025.0",
  leadTime: 3,
  orderQty: 50,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Drill",
  weigh: false,
},

{
  code: "DR-10MM-COBALT",
  description1: "Drill Bit 10mm Cobalt",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/DR-10MM-COBALT.png",
  itemType: ItemType.DURABLE,
  unitPrice: 15.00,
  issueCost: 18.00,
  uom: 'EA',
  packQty: 10,
  supCode: "SUP003",
  mfg: "Guhring",
  mfgItem: "5510-10.000",
  leadTime: 5,
  orderQty: 30,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Drill",
  weigh: false,
},
{
  code: "DR-3MM-HSS",
  description1: "Drill Bit 3mm HSS",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/DR-3MM-HSS.png",
  itemType: ItemType.EXPENDABLE,
  unitPrice: 4.00,
  issueCost: 5.50,
  uom: 'EA',
  packQty: 25,
  supCode: "SUP002",
  mfg: "OSG",
  mfgItem: "EX-GDS-3.0",
  leadTime: 4,
  orderQty: 60,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Drill",
  weigh: false,
},
{
  code: "SF-HSK63A-1IN",
  description1: "Shrink-Fit Holder HSK63A 1in Bore",
  description2: '1.000" Bore, 4.5276" Projection',
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/SF-HSK63A-1IN.jpg",
  itemType: ItemType.DURABLE,
  unitPrice: 311.00,
  issueCost: 40.00,
  uom: "EA",
  packQty: 1,
  supCode: "SUP005",
  mfg: "HAIMER",
  mfgItem: "A63.140.1Z.00",
  leadTime: 14,
  orderQty: 2,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Tool Holder",
  weigh: false,
  notes: "HSK63A taper, 1.7323in nose dia, 2.2835in clamp depth, MSC#50267079",
},
{
  code: "SF-BT40-12MM",
  description1: "Shrink-Fit Holder BT40 12mm Bore Through Coolant",
  description2: '0.4724" Bore, 3.543" Projection, Through Coolant',
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/SF-BT40-12MM.jpg",
  itemType: ItemType.DURABLE,
  unitPrice: 400.00,
  issueCost: 35.00,
  uom: "EA",
  packQty: 1,
  supCode: "SUP004",
  mfg: "Seco",
  mfgItem: "00034391",
  leadTime: 14,
  orderQty: 2,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Tool Holder",
  weigh: false,
  notes: "BT40 taper, 0.787in nose dia, 1.338in clamp depth, MSC#60139714",
},
{
  code: "84CutDia",
  description1: "84mm Cut Dia, 80mm Arbor Hole Dia, 15.4mm Max Depth, Indexable Square-Shoulder Face Mill",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/84CutDia.jpg",
  itemType: ItemType.DURABLE,
  unitPrice: 670.00,
  issueCost: 40.00,
  uom: "EA",
  packQty: 1,
  supCode: "SUP003",
  mfg: "Iscar",
  mfgItem: "F90LN-D080-06",
  leadTime: 14,
  orderQty: 1,
  dateCreated: new Date("2024-01-15"),
  active: true,
  disabled: false,
  category: "Cutting Tool",
  weigh: false,
},
{
  code: "4cutdia",
  description1: '4" Cut Dia, 1-1/2" Arbor Hole Dia, 0.433" Max Depth, Indexable Square-Shoulder Face Mill',
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/4cutDia.jpg",
  itemType: ItemType.DURABLE,
  unitPrice: 475.00,
  issueCost: 55.00,
  uom: "EA",
  packQty: 1,
  supCode: "SUP004",
  mfg: "Seco",
  mfgItem: "02689826",
  leadTime: 15,
  orderQty: 1,
  dateCreated: new Date("2024-01-15"),
  active: true,
  disabled: false,
  category: "Cutting Tool",
  weigh: false,
},
{
  code: "FM-125MM-10T",
  description1: "Face Mill 125mm 10 Insert Shell Mill",
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/FM-125MM-10T.png",
  itemType: ItemType.DURABLE,
  unitPrice: 650.00,
  issueCost: 75.00,
  uom: "EA",
  packQty: 1,
  supCode: "SUP005",
  mfg: "Walter",
  mfgItem: "F4042.B125.10",
  leadTime: 18,
  orderQty: 1,
  dateCreated: new Date("2024-01-15"),
  active: true,
  disabled: false,
  category: "Cutting Tool",
  weigh: false,
},
{
  code: "GW-8X1-60G",
  description1: "Grinding Wheel 8in x 1in Silicon Carbide 60 Grit",
  description2: 'Type 1, 8" x 1" x 1", Silicon Carbide, 60 Grit',
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/GW-8X1-60G.jpg",
  itemType: ItemType.EXPENDABLE,
  unitPrice: 32.50,
  issueCost: 6.00,
  uom: "EA",
  packQty: 1,
  supCode: "SUP013",
  mfg: "NORTON",
  mfgItem: "66253044087",
  leadTime: 5,
  orderQty: 10,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Abrasive",
  weigh: false,
  notes: "Type 1 straight wheel, MSC#5A892",
},
{
  code: "MP-1IN-60G",
  description1: "Mounted Point 1in Aluminum Oxide 60 Grit",
  description2: 'W242, 1" Thick, 1/4" Shank, 60 Grit, Medium',
  itemImage: "https://d3jdpongi7ohqb.cloudfront.net/MP-1IN-60G.jpg",
  itemType: ItemType.EXPENDABLE,
  unitPrice: 4.25,
  issueCost: 1.25,
  uom: "EA",
  packQty: 10,
  supCode: "SUP013",
  mfg: "Tru-Maxx",
  mfgItem: "66253292108",
  leadTime: 5,
  orderQty: 50,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "Abrasive",
  weigh: false,
  notes: "Pink aluminum oxide, 1-1/2in shank length, MSC#89680060",
},
{
  code: "CL-123",
  description1: "Swiffer 360 Dusters, Heavy Duty Refills, 11 Count",
  description2: '',
  itemImage: "https://images.barcodespider.com/upcimage/037000990352.jpg",
  itemType: ItemType.EXPENDABLE,
  unitPrice: 57.68,
  issueCost: 57.68,
  uom: "qty",
  packQty: 10,
  supCode: "SUP012",
  mfg: "Procter & Gamble - Pampers",
  mfgItem: "037000990352",
  leadTime: 5,
  orderQty: 1,
  dateCreated: new Date(),
  active: true,
  disabled: false,
  category: "",
  weigh: false,
  notes: "",
},
];